module.exports = __webpack_public_path__ + "static/media/vaisseau.86efb7c0.mp3";